export class MicroFrontendLoader extends HTMLElement {
  connectedCallback() {
    // Attaching a shadow DOM to the element might break modals in Safari.
    const script = document.createElement('script');
    // eslint-disable-next-line fp/no-mutation
    script.src = this.getAttribute('src') ?? '';
    this.appendChild(script);
  }
}
